import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=c3d6c7de&scoped=true&lang=pug&"
import script from "./Preference.vue?vue&type=script&lang=js&"
export * from "./Preference.vue?vue&type=script&lang=js&"
import style0 from "./Preference.vue?vue&type=style&index=0&id=c3d6c7de&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d6c7de",
  null
  
)

/* custom blocks */
import block0 from "@/lang/views/preference.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fviews%2FPreference.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports